module.exports = __webpack_public_path__ + "img/logo.5c501c0f.png";